import { c as _c } from "react/compiler-runtime";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { vehicleTypeColors } from "@/styles/theme";
import { TrajectoryPointDtoVehicleType } from "@/api/generated/models/trajectoryPointDtoVehicleType";
import { vehicleTypeLabels } from "@/utils/vehicleTypeUtils";
export const VehicleTypeLegend = t0 => {
  const $ = _c(12);
  const {
    displayedVehicleTypes,
    availableVehicleTypes
  } = t0;
  const intl = useIntl();
  let t1;
  if ($[0] !== availableVehicleTypes || $[1] !== displayedVehicleTypes) {
    t1 = availableVehicleTypes ? displayedVehicleTypes.filter(t => availableVehicleTypes.includes(t)) : displayedVehicleTypes;
    $[0] = availableVehicleTypes;
    $[1] = displayedVehicleTypes;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const types = t1;
  let t2;
  if ($[3] !== intl || $[4] !== types) {
    let t3;
    if ($[6] !== intl) {
      t3 = type => ({
        color: vehicleTypeColors[type],
        label: intl.formatMessage(vehicleTypeLabels[type])
      });
      $[6] = intl;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = types.map(t3);
    $[3] = intl;
    $[4] = types;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const items = t2;
  if (items.length === 0) {
    return null;
  }
  let t3;
  if ($[8] !== items) {
    t3 = items.map(_temp);
    $[8] = items;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <Flex data-testid="legend-vehicle-type-bar" role="img" aria-label="Vehicle type color legend" direction="column" gap="1">{t3}</Flex>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(item, index) {
  return <Flex key={item.label} data-testid={`legend-segment-${index}`} align="center" gap="4"><Text data-testid={`legend-segment-label-${index}`} fontSize="sm" color="textMuted" flexShrink={0} width="legendLabel">{item.label}</Text><Box flex="1" height="4px" borderRadius="pill" bg={item.color} /></Flex>;
}